/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidy up messy text — trim each line, collapse repeated spaces and tabs, and drop blank lines, with a before/after character count.`)
};

const es_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordena texto desordenado — recorta cada línea, colapsa espacios y tabulaciones repetidas, y elimina líneas en blanco, con un recuento de caracteres antes/después.`)
};

const de_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räumen Sie unordentlichen Text auf — trimmen Sie jede Zeile, fassen Sie wiederholte Leerzeichen und Tabulatoren zusammen und entfernen Sie Leerzeilen, mit einer Vorher/Nachher-Zeichenzählung.`)
};

const nl_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak rommelige tekst netjes — trim elke regel, vouw herhaalde spaties en tabs in en verwijder lege regels, met een voor/na-tekencount.`)
};

const fr_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyez le texte mal formaté — supprimez les espaces de chaque ligne, réduisez les espaces et tabulations répétés, et éliminez les lignes vides, avec un compte de caractères avant/après.`)
};

const it_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina il testo disordinato — taglia ogni riga, comprimi gli spazi e tabulazioni ripetuti e elimina le righe vuote, con un conteggio dei caratteri prima/dopo.`)
};

const pt_br2_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize texto desorganizado — aparar cada linha, colapsar espaços e abas repetidos e remover linhas em branco, com uma contagem de caracteres antes/depois.`)
};

const pt_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize texto desorganizado — apare cada linha, colapsar espaços e abas repetidas, e remova linhas em branco, com uma contagem de caracteres antes/depois.`)
};

const ja_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汚いテキストを整理 — 各行をトリム、繰り返されたスペースとタブを圧縮、空白行を削除し、文字数の前後を表示します。`)
};

const zh_wsc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整理杂乱的文本 — 修剪每一行，合并重复的空格和制表符，并删除空行，同时提供处理前后的字符数统计。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_intro", locale)
	if (locale === "en") return en_wsc_intro(inputs)
	if (locale === "es") return es_wsc_intro(inputs)
	if (locale === "de") return de_wsc_intro(inputs)
	if (locale === "nl") return nl_wsc_intro(inputs)
	if (locale === "fr") return fr_wsc_intro(inputs)
	if (locale === "it") return it_wsc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_intro(inputs)
	if (locale === "pt") return pt_wsc_intro(inputs)
	if (locale === "ja") return ja_wsc_intro(inputs)
	return zh_wsc_intro(inputs)
};